import './Header.css';
import LogoIcon from '../../assets/icons/brand-icon.png';
import { useAuth } from '../../contexts/AuthContext';

export default function Header({ sidebarOpen, onToggleSidebar }) {
  const { userInfo } = useAuth();

  return (
    <header className="app-header">
      <div className="header-left">
        <button className={`hamburger-btn ${sidebarOpen ? 'open' : ''}`} onClick={onToggleSidebar} aria-label="Меню">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="company-logo">
          <div className="logo"><img src={LogoIcon} alt="S-P"/></div>
          <span className="company-name">Smart Plan</span>
        </div>
      </div>
      <div className="header-right">
        <div className="user-info">
          <div className="user-name-role">
            <span className="user-name">{userInfo?.full_name}</span>
            <span className="user-role">{userInfo?.role}</span>
          </div>
        </div>
      </div>
    </header>
  );
}
